import './AppDialog.scss';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DialogData } from '../../../models/app';

interface Props {
  data: DialogData;
  open: boolean;
  onClose: Function| any;
  disableClose?: boolean;
}


const AppDialog = ({data, open, onClose, disableClose}: Props) => {
  
  return (
    <Dialog
      className="app-dialog"
      disableEscapeKeyDown
      onClose={!disableClose ? onClose : null}
      open={open}
      maxWidth="lg"
    >
      <DialogTitle>
        <div>
          {data.icon && data.icon}
          <h2 className="dialog-title">{data.title}</h2>
        </div>
      </DialogTitle>
      
      <DialogContent className="dialog-content">
        <p id= "app-dialog-description" dangerouslySetInnerHTML={{ __html: data.description}} />
        {data.support && <p className="dialog-content__support" dangerouslySetInnerHTML={{ __html: data.support}} />}
      </DialogContent>

      <DialogActions>
        <div className="c-dialog-actions">
          <Button className="btn-dialog--white" onClick={() => data.handleSecondaryAction()}>​​​
            {data.secondaryActionLabel}
          </Button>
          <Button className="btn-dialog--black" onClick={() => data.handleAction()}>
            {data.actionLabel}
          </Button>
        </div>
      </DialogActions> 
    </Dialog>
  );
};

export default AppDialog;
